<div class="share-modal scrollbar">
  <div class="loaded-content">
    <div class="modal-header">
      <h4 class="modal-title">{{newTitle}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modalDismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body link-share-body">
      <h4 class="modal-sub-title">Share using a Link</h4>
      <div>
        <form [formGroup]="shareModalFormGroup">
          <app-input [props]="inputPropsLink" formControlName="link"></app-input>
        </form>
        <div class="modal-notice show-info">
          {{copyToClipboardNotice}}
        </div>
      </div>
    </div>
    <div class="modal-footer share-button social-share-footer">
      <div class="social-share-container">
        <div class="ms-teams-wrapper" (click)="openShareToTeamsPopup()">
          <img [src]="msTeamLogo" alt=""/>
          <span>Share to Teams</span>
        </div>
        <div class="email-wrapper" (click)="openMailto()">
          <em class="icon-mail"></em>
          <span>Share to Email</span>
        </div>
      </div>
      <button
        type="button"
        _ti_copy_to_clipboard="copy_to_clipboard"
        class="btn-modal-primary share-btn"
        (click)="onCopyItemUrl()"
        [disabled]="!linkReady"
      >
        {{this.copyButtonText}}
      </button>
    </div>
  </div>
</div>
